import dayjs from "dayjs";
import { useGetAbsencesQuery, useGetPublicHolidaysQuery } from "../../../../api/plamo-api";
import { ActionTableState } from "../../action-table/action-table";
import { calculateWorkDays } from "../../util/work-days";
import { useNavigate } from "react-router-dom";

const createGetAbsencesQueryHook = (employeeId: number, reason: string, comparator: string) => {
  const useGetAbsencesWithFilterQuery = ({ f, ...rest }) => {
    const filter = JSON.parse(f || "{}");
    filter["employee.id"] = {
      c: "EQ",
      v: employeeId
    }
    filter["reason"] = {
      c: comparator,
      v: reason
    }
    return useGetAbsencesQuery({ f: JSON.stringify(filter), ...rest });
  }
  return useGetAbsencesWithFilterQuery
}

function EmployeeAbsenceList({ employeeId, reason, comparator }) {
  const navigate = useNavigate();
  const { data: publicHolidays } = useGetPublicHolidaysQuery({ }) as any;
  const columns = [
     {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Beginn",
      dataIndex: "begin",
      sorter: true,
      filter: true,
      type: 'date',
    },
    {
      title: "Ende",
      dataIndex: "end",
      sorter: true,
      filter: true,
      type: 'date',
    },
    {
      title: "Arbeitstage",
      dataIndex: "begin",
      sorter: true,
      filter: true,
      render: (_, item) => calculateWorkDays(dayjs(item.begin), dayjs(item.end), publicHolidays?.items || [])
    },
    {
      title: "Grund",
      dataIndex: "reason",
      sorter: true,
      filter: true,
    },
  ]

  return <ActionTableState
    buttonRow={{
      buttons: [
        {
          text: 'Neu',
          buttonType: 'primary',
          onClick: () => navigate(`./new`)
        },
      ]
    }}
    tableData={{
      defaultSortKey: 'id',
      columns,
      dataSource: {
        pageableQueryEndpoint: createGetAbsencesQueryHook(employeeId, reason, comparator),
        queryResultMapping: (result) => result?.items
      },
      actions: [
        {
          caption: 'Details',
          onClick: (item) => navigate(`./${item.id}`)
        },
      ]
    }}
  />
}

export default EmployeeAbsenceList;